import Vue from "./vue";

import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import { mapGetters } from "vuex";
import vuetify from "./plugins/vuetify";
import currentUserCan from "@/components/lib/currentUserCan.vue";
import pcnzDhbSelect from "@/components/lib/pcnz-dhb-select.vue";
import restResourceTable from "@/components/lib/RestResourceTable.vue";

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");

Vue.component("currentUserCan", currentUserCan);
Vue.component("restResourceTable", restResourceTable);
Vue.component("pcnzDhbSelect", pcnzDhbSelect);
Vue.mixin({
  methods: {
    currentUserCan(permission, ignoreAdmin = false) {
      try {
        const user = this.$store.getters.currentUser;

        //Admins get access to everything
        if (
          !ignoreAdmin &&
          user.rolemapping.find(rm => rm?.role?.name === "administrator")
        ) {
          return true;
        }

        let currentUserPerms = user.rolemapping
          .filter(rm => rm.role.permissions.length)
          .map(rm => {
            return rm.role?.permissions?.map(p => p.permission);
          })
          .reduce((p, array = []) => array.concat(p));

        console.log("currenUserPerms: ", currentUserPerms);

        return currentUserPerms.includes(permission);
      } catch (e) {
        console.error("unable to get currentuserPerms: ", e);
        return false;
      }
    }
  }
});
Vue.mixin({
  computed: {
    ...mapGetters({ lookup: "lookup" })
  }
});
